// @ts-nocheck
import { DialogShowId, viewActionTypes as events } from 'store/view/view.actions';
import type { ViewState } from 'types/store/view-state';
import type { APIReturn } from 'types/storeTypes';

export const initialState: ViewState = {
  dialogs: {
    count: 0,
    [DialogShowId.CONFIRM]: {
      active: false,
    },
    [DialogShowId.CUSTOM]: {
      active: false,
    },
    [DialogShowId.INVOICE]: {
      active: false,
    },
  },
};

const reducer = (state = initialState, action: APIReturn) => {
  let item;

  switch (action.type) {
    case events.dialog.show:
      item = action.payload;
      item.active = true;
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          count: state.dialogs.count + 1,
          [item.id]: item,
        },
      };
    case events.dialog.hide:
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          count: state.dialogs.count - 1,
          // @ts-expect-error
          [action.payload]: { ...state.dialogs[action.payload], active: false },
        },
      };
    default:
      return state;
  }
};

export default reducer;
